import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setFilterOptions } from '@yme/pdp-components/ProductCard';
import { getAvailableSkuBySizeValue } from '@yme/pdp-components/ProductCard/components/ProductFilter/helpers';
export function useSelectNewValue({ size, sku, variantsOfProduct }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const selectNewValue = useCallback((value) => {
        if (value && size !== value) {
            const currentVariant = getAvailableSkuBySizeValue({
                colorVariants: variantsOfProduct,
                sizeValue: value,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    size: value,
                    sku: currentVariant.sku,
                    isFilterChanged: true,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, size, sku, variantsOfProduct]);
    return {
        selectNewValue,
    };
}
